<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>

    <!-- 自定义弹窗 - 全局显示 -->
    <transition name="popup-slide">
      <div v-if="popup.showPopup" class="popup-container">
        <div class="popup-wrapper">
          <custom-popup
            :visible="popup.showPopup"
            :shop-list="popup.shopList"
            @close="handleClosePopup"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import CustomPopup from '@/components/CustomPopup'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView,
    CustomPopup
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      popup: state => state.popup
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    handleClosePopup() {
      this.$store.dispatch('popup/hidePopup')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/mixin.scss";
  @import "~@/assets/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
    padding: 0;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }

  /* 全局弹窗样式 */
  .popup-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1999;
    pointer-events: none;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding: 20px;
  }

  .popup-wrapper {
    animation: popupBounce 0.3s ease-out;
    pointer-events: auto;
  }

  /* 弹窗动画 */
  .popup-slide-enter-active,
  .popup-slide-leave-active {
    transition: all 0.3s ease;
  }

  .popup-slide-enter,
  .popup-slide-leave-to {
    opacity: 0;
    transform: translateX(100px) scale(0.8);
  }

  @keyframes popupBounce {
    0% {
      transform: scale(0.8) translateX(100px);
      opacity: 0;
    }
    70% {
      transform: scale(1.05) translateX(0);
    }
    100% {
      transform: scale(1) translateX(0);
      opacity: 1;
    }
  }
</style>
